import { LocationService } from './../../_services/location.service';
import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MerchantService } from '../../_services/merchant.service';

@Component({
    selector: 'app-actions',
    templateUrl: './actions.component.html',
    styleUrls: ['./actions.component.scss'],
    standalone: false
})
export class ActionsComponent implements OnInit {
  private readonly router: Router = inject(Router);
  private readonly locationService: LocationService = inject(LocationService);

  public merchantService: MerchantService = inject(MerchantService);

  currentLanguage: string;

  ngOnInit(): void {
    this.locationService.currentLanguage$.subscribe(resp => this.currentLanguage = resp);
  }

  onChangeLanguage(language: string) {
    let myHref = window.location.href;

    const languages = ['/it/', '/en/', '/fr/'];
    languages.forEach(l => {
      if (myHref.search(l) !== -1) {
        this.currentLanguage = language;
        myHref = myHref.replace(l, '/' + language + '/');
        window.location.replace(myHref);
        this.locationService.setLanguage(this.currentLanguage);
      }
    });

  }

  navigateTo() {
    this.router.navigateByUrl('/public/registration');
  }

  redirect(url) {
    window.open(url, '_blank');
  }

  logout() {
    this.merchantService.logout();
  }

  navigateToSandbox() {
    let href = window.location.href.split('/');
    let ix = href.indexOf('public');
    if (ix === -1) {return; }
    href.splice(ix);
    href.push('sandbox');
    console.log('url: ', href);
    window.location.href = href.join('/');
  }

  leads(){
    this.merchantService.leads().subscribe(res=>{
      if(res){
        this.redirect(res.url)
      }
    })
  }
}